import Vue from 'vue'
import VueResouse from 'vue-resource'
import tlstore from './../store/tlconfig'
import md5 from 'js-md5'
Vue.use(VueResouse);
var ticket=''
const appid='1'
const app_version='1.0.0'
const platform='4'
var selectCoupon=null;

// Vue.component('jsonpApi',{
// 	methods : {
// 		get : function(url,success){
// 		Vue.http.jsonp("http://app.taluoshi.com/taluoshi/tlslist").then(  
//                 function(res){  
//                  success(res.body);
//             })
// 		}
// 	}
// })
export default{
	get : function(url,success){
		return Promise.resolve(Vue.http.jsonp(url));
	},
	getData : function(url){
		Vue.http.jsonp(url).then(  
			function(res){  
				return res.body;
			})
	},
	createParam: function(params){
		var ts=timest();
		var rand=parseInt(Math.random()*1000);
		var nonce=md5(ts+rand);
		params.format='jsonp'
		// params.callback='cb'
		params.appid=appid;
		params.app_version=app_version;
		params.platform=platform;
		params.time_stamp=ts;
		params.nonce=nonce;
		params.ticket=tlstore.state.user.ticket;
		params.uid=tlstore.state.user.uid
		let token=createToken(params);
		params.api_token=token
		let keys=Object.keys(params);
		let paramStr="";
		for(var i = 0; i < keys.length; i++) {
			if(paramStr.length>0) paramStr+="&";
           paramStr+=keys[i]+"="+params[keys[i]];
        }
		return paramStr;
	},
	getTime:function(timestamp){
		var date =  new Date(timestamp*1000);
		var y = 1900+date.getYear();
		var m = "0"+(date.getMonth()+1);
		var d = "0"+date.getDate();
		var h="0"+date.getHours();
		var M="0"+date.getMinutes();
		return y+"-"+m.substring(m.length-2,m.length)+"-"+d.substring(d.length-2,d.length)+" "+h.substring(h.length-2,h.length)+":"+M.substring(M.length-2,M.length);
	}
}
function timest() {
	var tmp = Date.parse( new Date() ).toString();
	tmp = tmp.substr(0,10);
	return tmp;
}
//排序的函数
function createToken(arys) { 
                //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
                var newkey = Object.keys(arys).sort();　　 
                //console.log('newkey='+newkey);
                // var newObj = {}; //创建一个新的对象，用于存放排好序的键值对
                var apiToken="";
                for(var i = 0; i < newkey.length; i++) {
                    //遍历newkey数组
                    apiToken+=newkey[i]+"="+arys[newkey[i]];
                    // newObj[newkey[i]] = arys[newkey[i]]; 
                    //向新创建的对象中按照排好的顺序依次增加键值对

                }
                apiToken+=tlstore.state.secret;
                return md5(apiToken); //返回排好序的新对象
            }


// WEBPACK FOOTER //
// ./src/api/jsonpapi.js